import { useCurrentBreakpoint } from "../../hooks/breakpoints.js";
import { useSoftKeyboardTracker } from "../../hooks/keyboard.js";
import { LayoutContextProvider } from "../../providers/layout-context.js";
import { ThemeProvider } from "../../providers/theme.js";
import { cn } from "../../utils/classnames.js";
import { FloatingActionButton } from "../atoms/floating-action-button.js";
import { LayoutContainer } from "../atoms/layout-container.js";
import { LinkButton } from "../atoms/link-button.js";
import { ThemeToggle, ThemeToggleFallback } from "../molecules/theme-toggle.js";
import { Toaster } from "../molecules/toaster.js";
import { LayoutLocaleSelector } from "../organisms/locale-selector.js";
import { WebsiteFooter } from "../organisms/website-footer.js";
import { WebsiteHeader } from "../organisms/website-header.js";
import { WebsiteMobileMenu } from "../organisms/website-mobile-menu.js";
import { WebsiteNavigationMenu } from "../organisms/website-navigation-menu.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useLingui } from "@lingui/react";
import { useIsClient } from "@bitcart/hooks";
// src/components/templates/website.tsx
const WebsiteLayout = ({ config, isHydrated = true, localeChangeHandler, classNames, children, ...props }) => {
	const { _: $__ } = useLingui();
	const isClient = useIsClient();
	const currentBreakpoint = useCurrentBreakpoint();
	useSoftKeyboardTracker();
	return /* @__PURE__ */ jsx(LayoutContextProvider, {
		isHydrated,
		layoutConfig: config,
		...props,
		children: /* @__PURE__ */ jsxs(ThemeProvider, { children: [/* @__PURE__ */ jsxs(LayoutContainer, {
			className: cn("bg-background flex min-h-screen flex-col", classNames?.root),
			children: [
				/* @__PURE__ */ jsx(LinkButton, {
					id: "main-content-link",
					href: "#main-content",
					size: "xl",
					className: cn(`
              focus:bottom-3
              md:focus:top-3
              focus:left-4
              md:focus:left-6 md:focus:h-10
              lg:focus:left-8
              important:px-6 important:py-3
              focus:important:fixed
              transition-scale sr-only
              focus:z-50
              focus-visible:not-sr-only focus-visible:ring-3
            `),
					children: $__({
						id: "wELyS0",
						message: "Skip to main content"
					})
				}),
				/* @__PURE__ */ jsx(WebsiteMobileMenu, {
					layoutControls: /* @__PURE__ */ jsx(LayoutLocaleSelector, { handleSelect: localeChangeHandler }),
					triggerRender: /* @__PURE__ */ jsx(FloatingActionButton, {}),
					classNames: { trigger: `
                md:hidden fixed z-40 bottom-[calc(env(safe-area-inset-bottom,0px)+var(--spacing)*4)]
                right-4
                [:root[data-soft-keyboard]_&]:hidden
              ` }
				}),
				/* @__PURE__ */ jsxs(WebsiteHeader, {
					className: "max-md:hidden",
					children: [
						/* @__PURE__ */ jsx(WebsiteNavigationMenu, {
							className: "md:flex hidden",
							inert: isClient && currentBreakpoint === "sm"
						}),
						isClient ? /* @__PURE__ */ jsx(ThemeToggle, { className: "max-md:hidden" }) : /* @__PURE__ */ jsx(ThemeToggleFallback, { className: "max-md:hidden" }),
						/* @__PURE__ */ jsx(LayoutLocaleSelector, {
							handleSelect: localeChangeHandler,
							classNames: { trigger: "max-md:hidden" }
						})
					]
				}),
				/* @__PURE__ */ jsx("main", {
					id: "main-content",
					className: "md:pt-16 flex-1 focus:outline-none",
					tabIndex: -1,
					children
				}),
				/* @__PURE__ */ jsx(WebsiteFooter, { classNames: { root: "max-md:pb-16" } })
			]
		}), /* @__PURE__ */ jsx(Toaster, { position: "top-center" })] })
	});
};
export { WebsiteLayout };

//# sourceMappingURL=website.js.map